import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { AnimatePresence } from "framer-motion";

// comps
import StaffCard from "./StaffCard";
import StaffModal from "./StaffModal";

//hooks
import useAxios from "../../hooks/useAxios";

// Style rules
import { Sizes } from "../../styles";

const App = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedStaffMember, setSelectedStaffMember] = useState(null);

	const { response: staffMembers } = useAxios("staff");

	// handles the scroll behaviour on open and closing of the Modal
	useEffect(() => {
		if (isModalOpen) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "scroll";
		}
	}, [isModalOpen]);

	// useEffect responsible for displaying the modal from a sharable url
	useEffect(() => {
		if (staffMembers.length > 0 && window.location.hash) {
			// we extract the staff member id from the Hash
			let trimmedIncomingStaffId = parseInt(
				window.location.hash.replace("#", "")
			);
			// find the member we want from the staff members array using the trimmed hash
			let selectedMember = staffMembers.find(
				(member) => member.id == trimmedIncomingStaffId
			);
			// we open the modal
			if (selectedMember) {
				toggleModal(selectedMember);
			}
		}
	}, [staffMembers]);

	const toggleModal = (staffMember) => {
		if (staffMember) {
			setSelectedStaffMember(staffMember);
			updateUrl(staffMember.id);
		} else {
			setSelectedStaffMember(null);
			window.history.pushState({}, "", window.location.pathname);
		}
		return setIsModalOpen((currentState) => !currentState);
	};

	const renderStaffCards = () => {
		return (
			staffMembers &&
			staffMembers.length > 0 &&
			staffMembers.map((staffMember) => {
				return (
					<StaffCard
						key={staffMember.id}
						staffMember={staffMember}
						toggleModal={toggleModal}
					/>
				);
			})
		);
	};

	const updateUrl = (staffMemberId) => {
		let urlParams;
		if (staffMemberId) {
			// we use the hash param in window.location to store the staff ID
			urlParams = "#" + staffMemberId;
		}
		window.history.pushState(null, "", urlParams);
	};

	return (
		<>
			<Grid>{renderStaffCards()}</Grid>
			<AnimatePresence>
				{isModalOpen && selectedStaffMember && (
					<StaffModal
						toggleModal={toggleModal}
						staffMember={selectedStaffMember}
					/>
				)}
			</AnimatePresence>
		</>
	);
};

export default App;

const Grid = styled.ul`
	display: ${(props) => (props.isEmpty ? "block" : "grid")};
	grid-template-columns: 1fr;
	gap: 2.5rem;
	margin: 0;
	padding: 5.9rem 0 8rem 0;
	max-width: unset;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
	}
`;
